// extracted by mini-css-extract-plugin
module.exports = {"text":"_1KOcZ","root":"jsPXO","button":"s+b8L"};